import { React, useState } from 'react'
import "./ContactUs.css"
import { Container, Row, Col, Form } from 'react-bootstrap'
import { Title } from '../../../../Components'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';

const ContactUs = ({ url, section }) => {

    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const { subjects } = section.data;

    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        companyEmail: "",
        phoneNumber: "",
        message: "",
        subject: ""
    });

    const handleChange = (e) => {
        if (e && e.target) {
            const { name, value } = e.target;
            setFormData({ ...formData, [name]: value });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        const payload = {
            first_name: formData.firstName,
            last_name: formData.lastName,
            phone_number: formData.phoneNumber,
            company_email: formData.companyEmail,
            subject: formData.subject,
            message: formData.message,
        };

        try {
            const response = await fetch(
                `${url}/api/method/filtrix.filtrix.doctype.contact_us_form.contact_us_form.contact_us_form`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                }
            );
            setIsSubmitting(false)
            if (response.ok) {
                // Handle successful response
                toast.success(
                    <>
                        Successfully Sent Message
                        <br />
                        Thank You
                    </>
                );
            } else {
                // Handle error response
                toast.error("Failed to send message");
            }
        } catch (error) {
            setIsSubmitting(false)
            // Handle network error
            toast.error("An error occurred. Please try again later.");
        }
        finally {
            setFormData({
                firstName: "",
                lastName: "",
                companyEmail: "",
                phoneNumber: "",
                message: "",
                subject: ""
            });
        }
    };

    return (
        <div className='contact-us'>
            <Container>
                <Form
                    onSubmit={handleSubmit}
                    style={{ opacity: isSubmitting ? 0.5 : 1 }}
                >
                    <Row>
                        <Col sm={6} xs={12}>
                            <Title
                                color={"#fff"}
                                overlay={"Contact"}
                                title={"Get in Touch"}
                                overlayColor={"#fff"}
                            />
                            <Row className='input-contact-container'>
                                <Col sm={6} xs={6}>
                                    <label>First Name</label>
                                    <input className='input-contact'
                                        name="firstName"
                                        type='text'
                                        value={formData.firstName}
                                        onChange={handleChange}
                                        disabled={isSubmitting}
                                        required
                                    />
                                </Col>
                                <Col sm={6} xs={6}>
                                    <label>Last Name</label>
                                    <input className='input-contact' type='text'
                                        name="lastName"
                                        value={formData.lastName}
                                        onChange={handleChange}
                                        disabled={isSubmitting}
                                        required
                                    />
                                </Col>
                            </Row>

                            <Row className='input-contact-container'>
                                <Col sm={6} xs={6}>
                                    <label>Company Email</label>
                                    <input className='input-contact' type='email'
                                        name="companyEmail"
                                        value={formData.companyEmail}
                                        onChange={handleChange}
                                        disabled={isSubmitting}
                                        required
                                    />
                                </Col>
                                <Col sm={6} xs={6}>
                                    <label>Phone Number</label>
                                    <input className='input-contact' type='text'
                                        name="phoneNumber"
                                        value={formData.phoneNumber}
                                        onChange={handleChange}
                                        disabled={isSubmitting}
                                        required
                                    />
                                </Col>
                            </Row>
                            {subjects && subjects.map((subject, index) => (
                                <Row className='input-contact-container'>
                                    <Col sm={12} xs={12}>
                                        <label>Select Subject?</label>
                                        <select
                                            name="subject"
                                            className='input-contact-select'
                                            value={formData.subject}
                                            onChange={handleChange}
                                            disabled={isSubmitting}
                                            required
                                        >
                                            <option value="" hidden>Please select subject of message</option>
                                            <option>{subject.subject_title}</option>

                                        </select>
                                    </Col>
                                </Row>)
                            )}
                            <Row className='input-contact-container'>
                                <Col sm={12} xs={12}>
                                    <label>Message</label>
                                    <input
                                        className='input-contact'
                                        type='text'
                                        name="message"
                                        placeholder='Write your message..'
                                        value={formData.message}
                                        disabled={isSubmitting}
                                        onChange={handleChange}
                                        required
                                    />
                                </Col>
                            </Row>
                            <div className='send-message-div'>
                                <button className='btn-contact'
                                    disabled={isSubmitting}
                                >Send Message</button>
                            </div>
                        </Col>
                        <Col sm={6} xs={12}>

                        </Col>
                    </Row>
                </Form>
            </Container>
            <ToastContainer />
        </div>
    )
}

export default ContactUs
